import React from 'react';
import { Check } from 'lucide-react';

const MultiSelectFilterDropdown = ({ 
  isOpen, 
  onClose, 
  options, 
  selectedValues, 
  onSelectionChange,
  filterType 
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute left-full top-0 ml-1 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
      <div className="py-1" role="menu">
        {options.map((option) => (
          <button
            key={option}
            className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center justify-between"
            onClick={() => onSelectionChange(option)}
          >
            <div className="flex items-center">
              <div className={`w-4 h-4 border rounded mr-3 flex items-center justify-center
                ${selectedValues.includes(option) ? 'border-blue-600 bg-blue-600' : 'border-gray-300'}`}>
                {selectedValues.includes(option) && (
                  <Check className="h-3 w-3 text-white" />
                )}
              </div>
              <span>{option}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectFilterDropdown; 